const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-4xl font-bold text-gray-800">
        Cette page n'existe pas.
      </h1>
    </div>
  );
}

export default NotFound;